import React, { useState, useEffect } from 'react';
import { flowRight, get, isNull, isEmpty } from 'lodash';
import { connect } from 'react-redux';
// import { setItem } from 'api/actions';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import Content from './Content';
import * as actions from '../actions';
import * as c from '../constant';

const INIT_FILTER = {
  transaction_status: '',
  q: '',
  module_type: 'BPLS',
  transaction_type: '',
  sort_by: 'desc',
  year: '',
  endorsing_office_id: '',
  endorsing_status: ''
};

export const bplsStatusOption = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR EVALUATION', value: 'FOR PERMIT PROCESS' },
  {
    label: 'FOR ENDORSING OFFICES ASSESSMENT',
    value: 'FOR ENDORSING OFFICES ASSESSMENT',
  },
  { label: 'FOR LICENSE ASSESSMENT', value: 'FOR LICENSE ASSESSMENT' },
  { label: 'FOR PAYMENT', value: 'PENDING' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'FOR PAYMENT CONFIRMATION', value: 'FOR PAYMENT CONFIRMATION' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'ISSUED', value: 'ISSUED' },
  { label: 'REVOKED', value: 'REVOKED' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'EXPIRED SOA', value: 'EXPIRED SOA' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'CANCELLED', value: 'CANCELLED' },
];

export const endorsingOfficeStatusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'APPROVED', value: 'APPROVED' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'REJECTED', value: 'REJECTED' },
]

const getType = (type) => {
  if (type === 'RENEWAL') {
    return 'RENEWAL';
  }
  if (type === 'CHANGE') {
    return 'CHANGE';
  }
  if (type === 'QUARTERLY') {
    return 'QUARTERLY';
  }
  if (type === 'DELINQUENT') {
    return 'DELINQUENT';
  }
  if (type === 'RETIREMENT') {
    return 'RETIREMENT';
  }
  return 'NEW';
};

function Applications({
  getPermitList,
  list,
  getItem,
  match,
  pager,
  isLoading,
  history,
  clearList,
  clearItem,
  getYearList,
  yearList,
  getEndorsingOfficeList,
  endorsingOfficeList
}) {
  // const dispatch = useDispatch();
  const [refreshList, setRefreshList] = useState('');
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);

  useEffect(() => {
    setFilter({
      ...INIT_FILTER,
      transaction_type: getType(match.params.transaction_type.toUpperCase()),
    });
  }, [match.params.transaction_type]);

  useEffect(() => {
    if (debouncedFilter?.transaction_type) getPermitList(debouncedFilter);

    return () => {
      clearList(c.LIST, []);
      clearItem(c.ITEM, {});
      clearList(c.INITIAL_COMPUTATION, []);
      clearList(c.CALCULATION, []);
      clearItem(c.SELECTED_CALCULATION, '');
    };
  }, [debouncedFilter]);

  useEffect(() => {
    if (!refreshList) {
      getItem(refreshList);
    }
    setRefreshList('');
  }, [refreshList]);

  useEffect(() => {
    const args = {
      type: debouncedFilter?.transaction_type
    }
    const endorsingOffice = {
      type: debouncedFilter?.transaction_type,
      my_offices: 1
    }

    getYearList(args);
    getEndorsingOfficeList(endorsingOffice)
  }, [debouncedFilter?.transaction_type]);

  const yearListOption = [
    { label: 'ALL YEARS', value: '' },
    ...(!isEmpty(yearList.data) ? yearList.data : []).map(year => ({
      label: year,
      value: year
    }))
  ];

  const endorsingOfficeListOption = [
    { label: 'ALL', value: '' },
      ...(!isEmpty(endorsingOfficeList.data) ? endorsingOfficeList.data : []).map(item => {
        return ({
        label: get(item, 'attributes.name'),
        value: get(item, 'id')
      })
    })
  ];

  // const onSetKeyWord = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });

  //   setCountChar(e.target.value.length);
  // };

  // const onSetStatusFilter = (key) => (e) => {
  //   setFilter({
  //     ...filter,
  //     [key]: e.value,
  //   });
  //   getPermitList({
  //     ...param,
  //     [key]: e.value, // transaction_status
  //   });
  // };

  // const debouncedSearchTerm = useDebounce(formData, 500);

  // useEffect(() => {
  //   if (debouncedSearchTerm && countChar >= 3) {
  //     setFilter({
  //       ...filter,
  //       keyword: formData.q,
  //       transaction_type: getType(),
  //     });
  //     getPermitList(param);
  //   } else {
  //     setFilter({
  //       ...filter,
  //       transaction_type: getType(),
  //     });
  //     getPermitList({
  //       module_type: 'BPLS',
  //       sort_by: 'asc',
  //       transaction_status: filter.transaction_status,
  //       transaction_type: getType(),
  //     });
  //   }
  // }, [debouncedSearchTerm]);

  const filterStatusOptions = () => {
    // remove/filter out the following keyValues from bplsStatusOption based on BPLS Application
    let keyValue = [];
    if (getType() === 'QUARTERLY') {
      keyValue = [
        'FOR PERMIT PROCESS',
        'FOR LICENSE ASSESSMENT',
        'FOR RESUBMISSION',
        'FOR DELIVERY',
        // 'RECEIVED',
      ];
    }
    if (getType() === 'DELINQUENT' || getType() === 'RETIREMENT') {
      keyValue = ['FOR PERMIT PROCESS', 'FOR DELIVERY'];
    }
    // if (getType() === "NEW" || getType() === "RENEWAL" || getType() === "CHANGE") {
    //   keyValue = ['PAID']
    // }

    return bplsStatusOption.filter(
      (item) => keyValue.indexOf(item.label) === -1
    );
  };

  // const onCallbackTimer = () => {
  //   getPermitList(filter);
  // };

  // useEffect(() => {
  //   dispatch(setItem(c.CALLBACK_TIMER, onCallbackTimer));
  // }, [getType()]);

  const bplsNotification = (item) => {
    return (
      ['BPLS'].indexOf(get(item, 'attributes.module_type')) > -1 &&
      ['NEW', 'RENEWAL', 'DELINQUENT', 'CHANGE', 'RETIREMENT'].indexOf(
        get(item, 'attributes.transaction_type')
      ) > -1 &&
      ['FOR LICENSE ASSESSMENT', 'FOR PERMIT PROCESS'].indexOf(
        get(item, 'included.bplsApplication.attributes.status')
      ) > -1 &&
      (isNull(
        get(item, 'included.bplsApplication.attributes.transmittal_no')
      ) ||
        isEmpty(
          get(item, 'included.bplsApplication.attributes.transmittal_no')
        ))
    );
  };

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="card-content-listing  pt-1 pl-0">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={filterStatusOptions()}
            notificationListConfig={bplsNotification}
            moduleName="Applications"
            // getData={getPermitList}
            // setParams={param}
            setKeyword={(e) =>
              handleOnChange(
                e?.target.name,
                e?.target.value
                // e?.target.value.length
              )
            }
            setStatusFilter={(props) =>
              handleOnChange('transaction_status', props?.value)
            }
            status={get(filter, 'transaction_status') || ''}
            keyword={get(filter, 'q') || ''}
            keywordPlaceholder="Search Transaction..."
            listName="Application"
            label="Application List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {get(
                    item,
                    'included.bplsApplication.attributes.business_name'
                  )}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {get(item, 'included.bplsApplication.attributes.bin') || ''}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={list}
            dataPager={pager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:bpls_id?`}
                    render={() => (
                      <Content
                        list={list}
                        refreshList={setRefreshList}
                        param={debouncedFilter}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:bpls_id?`}
                  render={() =>
                    !params.bpls_id && list.length > 0 ? (
                      <Redirect to={`${match.url}/${get(list, '0.id')}`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleSort={(props) => handleOnChange('sort_by', props?.value)}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
            yearOptions={yearListOption}
            setYearFilter={(props) =>
              handleOnChange('year', props?.value)
            }
            year={get(filter, 'year') || ''}
            hasYearFilter
            endorsingOfficeOptions={endorsingOfficeListOption}
            setEndorsingOfficeFilter={(props) =>
              handleOnChange('endorsing_office_id', props?.value)
            }
            endorsingOffice={get(filter, 'endorsing_office_id') || ''}
            hasEndorsingOfficeFilter={get(filter, 'transaction_status') === 'FOR ENDORSING OFFICES ASSESSMENT'}
            setEndorsingOfficeStatus={(props) => handleOnChange('endorsing_status', props?.value)}
            endorsingOfficeStatusOptions={endorsingOfficeStatusOptions}
            endorsingOfficeStatus={get(filter, 'endorsing_status') || ''}
          />
        )}
      />
    </div>
  );
}

const mapStateToProps = ({ api }) => {
  return {
    list: get(api, `${c.LIST}.list`) || [],
    pager: get(api, `${c.LIST}.pager`) || {},
    isLoading: api.loading.indexOf(c.LIST) > -1,
    yearList: get(api, `${c.GET_YEAR_LIST}.res`) || [],
    endorsingOfficeList: get(api, `${c.GET_ENDORSING_OFFICE_LIST}.res`) || [],
  };
};

const enhance = flowRight([withRouter, connect(mapStateToProps, actions)]);

Applications.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  getPermitList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  clearList: PropTypes.instanceOf(Function).isRequired,
  clearItem: PropTypes.instanceOf(Function).isRequired,
  getYearList: PropTypes.instanceOf(Function).isRequired,
  yearList: PropTypes.instanceOf(Object).isRequired,
  getEndorsingOfficeList: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficeList: PropTypes.instanceOf(Object).isRequired,
};

export default enhance(Applications);
